import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { Map, List } from 'immutable';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Button } from 'semantic-ui-react';

import * as shareLib from 'libs/shareLib';
import * as shareActions from 'modules/share';

import { ServiceShareCancelService } from 'components';

class CtServiceShareCancelService extends Component {
  constructor(props) {
    super(props);

    this.state = {
      onProgress: false,
      cancelModal: false
    };
  }

  mountCancelModal = () => {
    const { cancelModal } = this.state;

    if (cancelModal) {
      // 열려진 경우로 닫는다.
      this.setState({ cancelModal: false });
    } else {
      // 닫혀진 경우로 연다.
      this.setState({ cancelModal: true });
    }
  };

  cancelShareService = async () => {
    this.setState({ onProgress: true });

    const { shareInfo: { userServiceNo } } = this.props;

    const params = {};
    let isOk = true;
    if (userServiceNo) {
      params.userServiceNo = userServiceNo;
    } else {
      // 오류
      isOk = false;
    }

    if (isOk) {
      try {
        const { ShareActions } = this.props;
        await ShareActions.cancelShareService(params);
      } catch (e) {
        console.log(e);
      }
    } else {
      console.log('cancelShareService isOk fail!');
    }

    this.mountCancelModal();
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { onProgress, cancelModal } = this.state;
    const { isAuth, shareInfo } = this.props;
    const { mountCancelModal, cancelShareService } = this;

    return (
      <div>
        <Button
          className="bt-style-gleam share-button-gray"
          size="tiny"
          content={defineMessages(formatMessage({ id: 'CtServiceShareCancelService_1', defaultMessage: '제 거' }))}
          onClick={mountCancelModal}
          // color="orange"
        />
        {cancelModal && (
          <ServiceShareCancelService
            onProgress={onProgress}
            isAuth={isAuth}
            shareInfo={shareInfo}
            cancelShareService={cancelShareService}
            handleOnToggleCancelModal={mountCancelModal}
          />
        )}
      </div>
    );
  }
}

CtServiceShareCancelService.propTypes = {};
CtServiceShareCancelService.defaultProps = {};

const mapStateToProps = (state, props) => {
  return {
    isAuth: state.user.get('isAuth')
  };
};

const mapDispatchToProps = dispatch => ({
  ShareActions: bindActionCreators(shareActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CtServiceShareCancelService));



// WEBPACK FOOTER //
// ./src/script/containers/share/CtServiceShareCancelService.js